/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { memo, type MemoExoticComponent } from 'react';

import { jsx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation/controllers/analytics';
import { type StoreMemoryUpdate } from '@atlassian/conversation-assistant-store/controllers/chat/types';
import { StoreMemoryUpdateView as SharedStoreMemoryUpdateView } from '@atlassian/rovo-platform-ui-components/store-memory-update';

export interface StoreMemoryUpdateViewProps {
	storeMemoryUpdate: StoreMemoryUpdate;
	onOpenMemoryManagement?: () => void;
}

export const StoreMemoryUpdateView: MemoExoticComponent<
	({ storeMemoryUpdate, onOpenMemoryManagement }: StoreMemoryUpdateViewProps) => JSX.Element
> = memo(
	({ storeMemoryUpdate, onOpenMemoryManagement }: StoreMemoryUpdateViewProps): JSX.Element => {
		const { sendAnalyticsEvent } = useAnalytics();

		return (
			<SharedStoreMemoryUpdateView
				storeMemoryUpdate={storeMemoryUpdate}
				showBetaLabel={fg('rovo_memory_beta_label')}
				onView={() => {
					sendAnalyticsEvent({
						action: 'viewed',
						actionSubject: 'memoryUpdate',
						actionSubjectId: 'memoryUpdateDisclosure',
					});
				}}
				onExpandedChange={(isExpanded) => {
					sendAnalyticsEvent({
						action: isExpanded ? 'expanded' : 'collapsed',
						actionSubject: 'memoryUpdate',
						actionSubjectId: 'memoryUpdateToggle',
					});
				}}
				onManageMemoriesClick={() => {
					sendAnalyticsEvent({
						action: 'clicked',
						actionSubject: 'button',
						actionSubjectId: 'manageMemoriesButton',
					});
				}}
				onOpenMemoryManagement={onOpenMemoryManagement}
			/>
		);
	},
);
